const totalHeadTitleList: any[] = [
  {
    headTitle: "",
  },
  {
    headTitle: "請求件数",
  },
  {
    headTitle: "請求金額",
  },
  {
    headTitle: "入金件数",
  },
  {
    headTitle: "入金金額",
  },
];

const headTitleList: any[] = [
  { headTitle: "入金ID" },
  { headTitle: "番号" },
  { headTitle: "取引日時" },
  { headTitle: "入金額" },
  { headTitle: "単位掛け金チェック" },
  { headTitle: "摘要" },
  { headTitle: "銀行／支店" },
  { headTitle: "仕分け処理", dontNeedSort: true },
];

export { totalHeadTitleList, headTitleList };
